import React, { Suspense } from 'react';
import Loader from 'wrapper/loader';

// Iframe-embed entry points. PUBLIC + UNGATED — the parent LOS supplies
// tenant context via scope_context in the fm-embed-session postMessage,
// not via subdomain, and the backend's CSP frame-ancestors header is what
// gates which parent origins can iframe us.
//
// These routes are mounted at the TOP level of every router in app.jsx
// (not under the /:stateId? wrapper). That matters because:
//   1. Logged-in users use officerRoutes / organizationRoutes / consumerRoutes
//      which don't include the auth bundle — without a top-level mount, the
//      URL falls through to "/:stateId/documents" with stateId="embed" and
//      ends up rendering the role-specific Documents page instead.
//   2. Logged-out users would otherwise hit StateRouterBoundary, which
//      redirects to /:stateId/embed/documents when a stateId is persisted in
//      localStorage — also wrong destination.

const EmbedHost = React.lazy(() => import('pages/embed/EmbedHost'));
const EmbedDocuments = React.lazy(() => import('pages/embed/EmbedDocuments'));

const embedRoutes = [
  {
    path: '/embed',
    element: (
      <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
        <EmbedHost />
      </Suspense>
    ),
  },
  {
    path: '/embed/documents',
    element: (
      <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
        <EmbedDocuments />
      </Suspense>
    ),
  },
];

export default embedRoutes;
